import React, { useState } from "react"
import styles from "./styles"

import { FormControl, OutlinedInput } from "@mui/material"
import { InputLabel } from "@mui/material"
import { InputAdornment, IconButton } from "@mui/material"

import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"

export default function InputPassword(props) {
	const { label, value, setValue, onChange,  sx } = props

	const [showPassword, setShowPassword] = useState(() => false)
	// const [helperText, setHelperText] = useState(() => "")

	function handleChange(event) {
		const value = event.target.value

		setValue(value)
		if (onChange) onChange({ value })
	}

	return (
		<FormControl variant="outlined" sx={{ ...styles.container, ...sx }}>
			<InputLabel htmlFor={`input-text-${label}`} sx={styles.label}>
				{label}
			</InputLabel>

			<OutlinedInput
				id={`input-text-${label}`}
				label={label}
				type={showPassword ? "text" : "password"}
				value={value}
				onChange={handleChange}
				sx={styles.input(value)}
				endAdornment={
					<InputAdornment position="end">
						<IconButton onClick={() => setShowPassword(!showPassword)} edge="end" sx={styles.visibility}>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				}
			/>
		</FormControl>
	)
}
